import { render, staticRenderFns } from "./SurveyFriends.vue?vue&type=template&id=b1539590&"
import script from "./SurveyFriends.vue?vue&type=script&lang=js&"
export * from "./SurveyFriends.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports